exports.readFile = (file, limit = 4000) => {
  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onload = () => {
      let fileContentArray = reader.result.split(/\r\n|\n/);
      let contador = 1;
      const header = fileContentArray[0];
      fileContentArray = fileContentArray.filter(
        (item) => item.replaceAll(" ", "").length !== 0
      );
      const parts = fileContentArray.reduce((p, c, index) => {
        if (index === 0) return p;
        if (index > contador * limit) contador++;
        if (!p[contador - 1]) p[contador - 1] = `${header}\n` + `${c}\n`;
        else p[contador - 1] += `${c}\n`;
        return p;
      }, []);

      resolve({ result: parts, total: fileContentArray.length - 1 });
    };

    reader.onerror = function () {
      reject(reader.error);
    };

    reader.readAsText(file);
  });
};
